import * as TYPES from './types';
import util from '@/common/util';
export default {

    async [TYPES.FETCH_NBR_LIST]({ ids }) {
        if (!ids) {
            return; 
        }
        let objs = [];
        try {
            objs = JSON.parse(ids);
        } catch (err) {}
        let idsTemp = [];
        objs.forEach(item => {
            if (!item.isOurCustom) {
                idsTemp.push(item.id);
            }
        });
        let res = await this.axiosIns.post('/api-graphql', {
            query: `{nbrs(ids: "${idsTemp.join(
                ','
            )}"){id,name,backPic,url,tag,label,displayName,type}}`
        });
        let nbrs = res.data.nbrs,
            items = [];
        objs.forEach(item => {
            let nbr = item.isOurCustom ? item : nbrs.shift();
            if (nbr) {
                if (util.isString(nbr.tag) && nbr.tag) {
                    nbr.tagList = nbr.tag.split(',');
                }
                if (nbr.displayName) {
                    nbr.name = nbr.displayName; 
                }
                items.push(nbr);
            }
        });
        this.list = items;
    }
};
